import { FormGroup, AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { MatSnackBar, MatDialog } from '@angular/material';
import { ConvertService, removeObjArray } from 'src/app/services/convert.service';
import { AuthStore } from 'src/app/stores/auth/auth.store';
import { DataService } from 'src/app/services/data.service';
import { STATUS_OBJECT, DISPLAY_STATUS_OBJECT } from 'src/app/dummy/status';
import { COLLECTION_NAME, PRICE_OPTIONS, LANGUAGE_LIST } from 'src/app/dummy/app';
import { IReadingAudio } from 'src/app/interfaces/book-store';
import { BookstoreStore } from 'src/app/stores/bookstore/bookstore.store';
import { Observable } from 'rxjs';
import { MappingService } from 'src/app/services/mapping.service';
import { FireStorageService } from 'src/app/services/fire-storage.service';
import { DeleteComponent } from 'src/app/components/delete/delete.component';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';

@Component({
  selector: 'app-add-reading-audio-book',
  templateUrl: './add-reading-audio-book.component.html',
  styleUrls: ['./add-reading-audio-book.component.scss']
})
export class AddReadingAudioBookComponent implements OnInit {
  @ViewChild('focusInput', { static: false }) inputEl: ElementRef;

  @ViewChild('coverFile', { static: false }) coverFile: ElementRef;
  @ViewChild('sampleFile', { static: false }) sampleFile: ElementRef;
  @ViewChild('bookFile', { static: false }) bookFile: ElementRef;
  @ViewChild('bookAudioFile', { static: false }) bookAudioFile: ElementRef;

  ITEM_KEY: any;
  ITEM: IReadingAudio;
  TITLE: any = "Add new book"
  processNew: boolean = false;
  processClose: boolean = false;
  error: any = null;

  form: FormGroup;
  author: AbstractControl;
  publisher: AbstractControl;
  level: AbstractControl;
  type: AbstractControl;
  readingFormat: AbstractControl;


  START_UPLOAD: boolean = false;
  uploadPercent: Observable<number>;

  SELECTED_COVER_FILE: any[] = [];
  SELECTED_BOOK_FILE: any;
  SELECTED_AUDIO_BOOK_FILE: any[] = [];


  GENRES_LIST: any[] = [];
  SECTION_LIST: any;
  PUBLISHER_LIST: any;
  AUTHOR_LIST: any;
  PRICE_OPTIONS = PRICE_OPTIONS;
  LANGUAGE_LIST = LANGUAGE_LIST;

  READING_LEVEL: any[] = [];
  READING_TYPE: any[] = [];
  READING_FORMAT: any[] = [];

  READING_LEVEL_LIST: any;
  READING_TYPE_LIST: any;
  READING_FORMAT_LIST: any;

  READING_TARGET_AGE: any[] = [];
  LOADING: boolean = true;
  license: boolean = true;

  LICENSE_KEY: any;

  LEVEL_KEY: any = null;
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private auth: AuthStore,
    public store: BookstoreStore,
    public ds: DataService,
    private snackBar: MatSnackBar,
    private storage: FireStorageService,
    private dialog: MatDialog,
  ) { }

  compareWithObj(a: any, b: any): boolean {
    if (b) return a.key === b.key;
  }

  displayItem(item: any): string {
    return item ? item.name : item;
  }

  uploadFileCover(event) {
    if (event && event.target.files.length > 0) {
      for (let index = 0; index < event.target.files.length; index++) {
        const element = event.target.files[index];
        this.SELECTED_COVER_FILE.push(element)
      }
      this.coverFile.nativeElement.value = "";
    }
  }

  removeCoverFile(file) {
    const newFile = Array.from(this.SELECTED_COVER_FILE).filter(f => f.name !== file.name)
    this.SELECTED_COVER_FILE = newFile;

  }

  uploadFileBook(event) {
    if (event && event.target.files.length > 0) {
      this.SELECTED_BOOK_FILE = event.target.files[0];
      this.bookFile.nativeElement.value = "";
    }
  }

  removeBookFile() {
    this.SELECTED_BOOK_FILE = null;
  }

  uploadFileBookAudio(event) {
    if (event && event.target.files.length > 0) {
      for (let index = 0; index < event.target.files.length; index++) {
        const element = event.target.files[index];
        this.SELECTED_AUDIO_BOOK_FILE.push(element)
      }
      this.bookAudioFile.nativeElement.value = "";
    }
  }

  onDeleteAudio(file: any) {
    if (!this.ITEM) return;
    let dialogRef = this.dialog.open(DeleteComponent, {
      data: { title: 'Delete File', memo: 'File will delete from system.', name: file.name },
      width: '35vw',
      disableClose: true,
      role: 'dialog',
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'yes') {
        const { audioFileDetail } = this.ITEM;
        const fileItems = (audioFileDetail || null).filter(m => m.key !== file.key);
        this.ITEM.audioFileDetail = fileItems;
        this.store.addItem(COLLECTION_NAME.BOOK_STORE_BOOKS, this.ITEM, (success, res) => {
          this.snackBar.open("Audio reading has been deleted successful.", "Done", { duration: 1000 });
        })
      }
    });
  }

  onDeleteCover(file: any) {
    if (!this.ITEM) return;
    let dialogRef = this.dialog.open(DeleteComponent, {
      data: { title: 'Delete Cover', memo: 'Cover will delete from system.', name: file.name },
      width: '35vw',
      disableClose: true,
      role: 'dialog',
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'yes') {
        const { coverDownloadUrl, } = this.ITEM;
        const fileItems = removeObjArray(coverDownloadUrl || [], file.key);
        this.ITEM.coverDownloadUrl = fileItems;
        this.ITEM.coverFileName = fileItems.map(m => m.name)
        this.store.addItem(COLLECTION_NAME.BOOK_STORE_BOOKS, this.ITEM, (success, res) => {
          this.snackBar.open("Audio reading has been deleted successful.", "Done", { duration: 1000 });
        })
      }
    });
  }


  removeAudioFile(file) {
    const newFile = Array.from(this.SELECTED_AUDIO_BOOK_FILE).filter(f => f.name !== file.name)
    this.SELECTED_AUDIO_BOOK_FILE = newFile;
  }



  async ngOnInit() {
    this.SELECTED_COVER_FILE = []
    this.SELECTED_BOOK_FILE = null;
    this.SELECTED_AUDIO_BOOK_FILE = []
    this.form = this.fb.group({
      name: [null, Validators.required],
      description: [null],
      shortDescription: [null, Validators.required],
      author: [null, Validators.compose([Validators.required, MappingService.validSelected.bind(this)])],
      genres: [null, Validators.compose([Validators.required, MappingService.validSelected.bind(this)])],
      section: [null, Validators.required],
      price: [1.99, Validators.required],
      priceOption: [PRICE_OPTIONS[0], Validators.required],
      releasedDate: [new Date(), Validators.required],
      length: [null, Validators.required],
      publisher: [null, Validators.compose([Validators.required, MappingService.validSelected.bind(this)])],
      language: [LANGUAGE_LIST[0], Validators.required],
      words: [null, Validators.required],
      level: [null, Validators.compose([Validators.required, MappingService.validSelected.bind(this)])],
      type: [null, Validators.compose([Validators.required, MappingService.validSelected.bind(this)])],
      readingFormat: [null, Validators.compose([Validators.required, MappingService.validSelected.bind(this)])],
      targetAge: [null, Validators.compose([Validators.required])],
      copyright: [true,]
    })

    this.publisher = this.form.controls['publisher']
    this.author = this.form.controls['author']
    this.level = this.form.controls['level']
    this.type = this.form.controls['type']
    this.readingFormat = this.form.controls['readingFormat']
    this.route.queryParams.subscribe(params => {
      const { level } = params;
      this.LEVEL_KEY = level || null;
    })
    const author_list = await this.store.fetchListArray(COLLECTION_NAME.BOOK_STORE_AUTHOR, "name");
    const publisher_list = await this.store.fetchListArray(COLLECTION_NAME.BOOK_STORE_PUBLISHER, "name");
    this.GENRES_LIST = await this.store.fetchListArray(COLLECTION_NAME.BOOK_STORE_GENRES, "name");
    this.SECTION_LIST = await this.store.fetchListArray(COLLECTION_NAME.BOOK_STORE_SECTIONS, "name");

    this.READING_LEVEL = await this.store.fetchListArray(COLLECTION_NAME.READING_LEVEL, "name");
    this.READING_TYPE = await this.store.fetchListArray(COLLECTION_NAME.READING_TYPE, "name");
    this.READING_FORMAT = await this.store.fetchListArray(COLLECTION_NAME.READING_FORMAT, "name");
    this.READING_TARGET_AGE = await this.store.fetchListArray(COLLECTION_NAME.READING_TARGET_AGE, "name");
    this.READING_LEVEL_LIST = MappingService.autoComplete(this.level, this.READING_LEVEL, "name");

    this.READING_FORMAT_LIST = MappingService.autoComplete(this.readingFormat, this.READING_FORMAT, "name");
    this.READING_TYPE_LIST = MappingService.autoComplete(this.type, this.READING_TYPE, "name");

    this.PUBLISHER_LIST = MappingService.autoComplete(this.publisher, publisher_list, "name");
    this.AUTHOR_LIST = MappingService.autoComplete(this.author, author_list, "name");
    this.LOADING = false;
    this.route.params.subscribe(param => {
      const { id, typeKey } = param;
      this.license = `${typeKey}` === '0' ? false : true;
      this.LICENSE_KEY = typeKey;
      if (id !== 'draft') {
        this.ITEM_KEY = id;
        this.store.fetchSelectedData(COLLECTION_NAME.BOOK_STORE_BOOKS, this.ITEM_KEY, (doc: IReadingAudio) => {
          if (doc) {
            this.TITLE = "Edit audio reading"
            this.ITEM = doc;
            this.form.patchValue({
              name: doc.name,
              description: doc.description,
              shortDescription: doc.shortDescription,
              author: author_list.find(m => m.key === doc.authorKey) || null,
              genres: this.GENRES_LIST.find(m => m.key === doc.genresKey) || null,
              price: doc.price,
              priceOption: doc.priceOption,
              releasedDate: doc.releasedDate.toDate(),
              length: doc.length,
              publisher: publisher_list.find(m => m.key === doc.publisherKey) || null,
              language: doc.language,
              words: doc.words,
              level: doc.level,
              type: doc.type,
              readingFormat: doc.format,
              targetAge: doc.targetAge,
              section: doc.sectionKey,
              copyright: doc.copyright,
            })
            this.inputEl.nativeElement.focus();
            return;
          }
          else {
            this.ITEM = null;
            this.router.navigate([`/audio-reading/library`])
          }
        })
      }
      else {
        this.ITEM = null;
        this.ITEM_KEY = null;
        this.LOADING = false;
        this.form.patchValue({
          genres: this.GENRES_LIST[0],
        })
      }
    })
  }

  goBack() {
    this.router.navigate([this.LICENSE_KEY === '0' ? `/audio-reading/library` : `/book-store/books/submitted`], { queryParams: { level: this.LEVEL_KEY } })
  }

  newBook() {
    this.router.navigate([`/audio-reading/library/${this.LICENSE_KEY}/draft`], { queryParams: { level: this.LEVEL_KEY } })
  }


  async onSave(f: any, isNew: boolean) {
    if (this.form.valid) {
      this.processClose = true;
      this.error = null;
      if (this.SELECTED_COVER_FILE.length === 0 && !this.ITEM) {
        alert('Please select cover file');
        return;
      }
      this.form.disable();
      const { words, name, description, shortDescription, author,
        genres, section, publisher, price, priceOption,
        releasedDate, language, length, level, type,
        readingFormat, targetAge, copyright } = f;
      const { user } = this.auth;
      const registerStatus = isNew ? STATUS_OBJECT.submitted : STATUS_OBJECT.submitted;
      const sectionRef = section.map(m => this.ds.sectionsRef().doc(m).ref);
      const key = this.ITEM ? this.ITEM.key : this.ds.createId();
      const item: IReadingAudio = {
        key: key,
        status: DISPLAY_STATUS_OBJECT.ACTIVE,
        isDelete: false,
        created_at: this.ITEM ? this.ITEM.created_at : new Date(),
        created_by: this.ITEM ? this.ITEM.created_by : user.uid,
        updated_at: new Date(),
        updated_by: user.uid,
        date_key: this.ITEM ? this.ITEM.date_key : ConvertService.dateKey(),
        page_key: ConvertService.pageKey(),
        keyword: ConvertService.toCapitalize(`${name.trim()}`),
        organizationRef: null,
        organizationKey: null,
        created_byRef: this.ITEM ? this.ITEM.created_byRef : this.ds.userProfileRef().doc(user.uid).ref,
        updated_byRef: this.ds.userProfileRef().doc(user.uid).ref,
        register_status: registerStatus,
        //fields
        name: name.trim(),
        description,
        shortDescription,
        authorKey: author.key,
        authorRef: this.ds.authorRef().doc(author.key).ref,
        genresKey: genres.key,
        genresRef: this.ds.genresRef().doc(genres.key).ref,
        genres: genres,
        sectionKey: section,
        sectionRef: sectionRef,
        price,
        priceOption,
        releasedDate,
        length,
        publisherKey: publisher ? publisher.key : null,
        publisherRef: publisher ? this.ds.sectionsRef().doc(publisher.key).ref : null,
        language,
        words,
        level,
        type,
        targetAge,
        format: readingFormat,
        audioFileDetail: this.ITEM ? this.ITEM.audioFileDetail : null,
        bookFileDetail: this.ITEM ? this.ITEM.bookFileDetail : null,
        coverFileName: this.ITEM ? this.ITEM.coverFileName : [],
        coverDownloadUrl: this.ITEM ? this.ITEM.coverDownloadUrl : [],
        license: this.license || false,
        audiobook: this.ITEM ? this.ITEM.audiobook : false,
        copyright: copyright || false,
      }
      const selectedCoverFiles: any[] = [];
      if (this.SELECTED_COVER_FILE.length > 0) {
        for (let index = 0; index < this.SELECTED_COVER_FILE.length; index++) {
          this.START_UPLOAD = true;
          const file = this.SELECTED_COVER_FILE[index];
          const soundPath = `/READING_BOOK/${key}/files/${file.name}`;
          const soundTask = this.storage.uploadSelectedFile(file, soundPath);
          this.uploadPercent = soundTask.percentageChanges();
          const downloadURL: any = (await soundTask.then(async (f) => {
            return f.ref.getDownloadURL()
          }));
          let fileType = file.type.split('/').slice(0, -1).join('/');
          const files = {
            key: this.ds.createId(),
            filename: soundPath,
            name: file.name,
            downloadUrl: downloadURL,
            fileType: file.type,
            type: fileType,
            fileSize: file.size,
          }
          selectedCoverFiles.push(files)
          this.START_UPLOAD = false;
        }
        this.SELECTED_COVER_FILE = [];
        item.coverDownloadUrl = selectedCoverFiles;
        item.coverFileName = selectedCoverFiles.map(m => m.name);
      }
      if (this.SELECTED_BOOK_FILE) {
        this.START_UPLOAD = true;
        const file: any = this.SELECTED_BOOK_FILE;
        const soundPath = `/READING_BOOK/${key}/files/${file.name}`;
        const soundTask = this.storage.uploadSelectedFile(file, soundPath);
        this.uploadPercent = soundTask.percentageChanges();
        const downloadURL: any = (await soundTask.then(async (f) => {
          return f.ref.getDownloadURL()
        }));
        let fileType = file.type.split('/').slice(0, -1).join('/');
        const files = {
          key: this.ds.createId(),
          filename: soundPath,
          name: file.name,
          downloadUrl: downloadURL,
          fileType: file.type,
          type: fileType,
          fileSize: file.size,
        }
        item.bookFileDetail = files;
        this.SELECTED_BOOK_FILE = null;
        this.START_UPLOAD = false;
      }

      let selectedAudioFiles: any = this.ITEM ? this.ITEM.audioFileDetail || null : null;
      if (this.SELECTED_AUDIO_BOOK_FILE.length > 0) {
        if (selectedAudioFiles === null) {
          selectedAudioFiles = []
        }
        for (let index = 0; index < this.SELECTED_AUDIO_BOOK_FILE.length; index++) {
          this.START_UPLOAD = true;
          const file = this.SELECTED_AUDIO_BOOK_FILE[index];
          const soundPath = `/READING_BOOK/${key}/files/${file.name}`;
          const soundTask = this.storage.uploadSelectedFile(file, soundPath);
          this.uploadPercent = soundTask.percentageChanges();
          const downloadURL: any = (await soundTask.then(async (f) => {
            return f.ref.getDownloadURL()
          }));
          let fileType = file.type.split('/').slice(0, -1).join('/');
          const files = {
            key: this.ds.createId(),
            filename: soundPath,
            name: file.name,
            downloadUrl: downloadURL,
            fileType: file.type,
            type: fileType,
            fileSize: file.size,
          }
          selectedAudioFiles.push(files)
          this.START_UPLOAD = false;
        }
        this.SELECTED_AUDIO_BOOK_FILE = [];
        item.audioFileDetail = selectedAudioFiles;
        item.audiobook = true;
      }

      this.store.addItem(COLLECTION_NAME.BOOK_STORE_BOOKS, item, (success, res) => {
        if (success) {
          this.router.navigate([`/audio-reading/library/${this.LICENSE_KEY}/${item.key}`])
          this.snackBar.open("Book has been saved successful.", "Done", { duration: 2500 });
          this.form.reset();
        }
        this.form.enable();
        this.processNew = false;
        this.processClose = false;
        this.inputEl.nativeElement.focus();
        this.SELECTED_COVER_FILE = [];
        this.SELECTED_BOOK_FILE = null;
        this.SELECTED_AUDIO_BOOK_FILE = [];
        this.bookAudioFile.nativeElement.value = ""
        this.coverFile.nativeElement.value = "";
        this.bookFile.nativeElement.value = "";
        this.START_UPLOAD = false;
        this.form.patchValue({ copyright: copyright })
        if (isNew) {
          this.newBook();
        }
        else {
          this.ITEM = item;
        }
        if (this.ITEM_KEY) {
          this.goBack();
        }
      })

    }
  }

}
